import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainNavbar from "./components/navbar";
import SiteModeProvider from "./components/SiteModeProvider";
import CookieConsentProvider from "./components/CookieConsent/CookieConsentContext";
import { RETAIL_ROUTES, LEGACY_REDIRECTS } from "./lib/siteMode";
import DualEducation from "./landings/corporate/DualEducation";
import NemzetiBajnokok from "./landings/corporate/NemzetiBajnokok";
import ElmaradottTersegBruhazas from "./landings/corporate/ElmaradottTersegBruhazas";
import BusinessLoanConsulting from "./landings/corporate/BusinessLoanConsulting";
import CorporateAccountOptimize from "./landings/corporate/CorporateAccountOptimize";
import Footer from "./components/footer";
import PrivacyPolicy from "./landings/PrivacyPolicy";
import Container from "react-bootstrap/Container";
import Impresszum from "./landings/Impresszum";
import Rolunk from "./landings/Rolunk";
import ThanksPage from "./landings/ThanksPage";
import ThanksPageRetail from "./landings/retail/ThanksPageRetail";
import FrameworkContract from "./landings/corporate/FrameworkContract";
import VallalatiHome from "./landings/VallalatiHome";
import LakossagiHome from "./landings/LakossagiHome";
import Jelzaloghitel from "./landings/retail/Jelzaloghitel";
import SzemelyiKolcson from "./landings/retail/SzemelyiKolcson";
import LakossagiBankszamla from "./landings/retail/LakossagiBankszamla";
import Nyugdijmegtakaritas from "./landings/retail/Nyugdijmegtakaritas";
import Eletbiztositas from "./landings/retail/Eletbiztositas";

export default function App() {
  return (
    <BrowserRouter>
      <SiteModeProvider>
        <CookieConsentProvider>
          <MainNavbar />
          <Routes>
            {/* Retail (lakossági) — default page at "/" */}
            <Route path="/" element={<LakossagiHome />} />
            <Route path="/lakossagi" element={<LakossagiHome />} />

            {/* Corporate (vállalati) */}
            <Route path="/vallalati" element={<VallalatiHome />} />
            <Route path="/nemzeti-bajnokok" element={<NemzetiBajnokok />} />
            <Route path="/dualis-kepzes" element={<DualEducation />} />
            <Route
              path="/elmaradott-tersegek-tamogatasa"
              element={<ElmaradottTersegBruhazas />}
            />
            <Route
              path="/vallalati-hitel"
              element={<BusinessLoanConsulting />}
            />
            <Route
              path="/szamlaoptimalizalas"
              element={<CorporateAccountOptimize />}
            />
            <Route path="/penzugyi-orangyal" element={<FrameworkContract />} />

            {/* Retail (lakossági) — nested products */}
            <Route
              path={RETAIL_ROUTES.jelzaloghitel}
              element={<Jelzaloghitel />}
            />
            <Route
              path={RETAIL_ROUTES.szemelyiKolcson}
              element={<SzemelyiKolcson />}
            />
            <Route
              path={RETAIL_ROUTES.bankszamla}
              element={<LakossagiBankszamla />}
            />
            <Route
              path={RETAIL_ROUTES.nyugdijmegtakaritas}
              element={<Nyugdijmegtakaritas />}
            />
            <Route
              path={RETAIL_ROUTES.eletbiztositas}
              element={<Eletbiztositas />}
            />

            {/* Legacy flat retail paths → nested equivalents */}
            {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
              <Route
                key={from}
                path={from}
                element={<Navigate to={to} replace />}
              />
            ))}

            {/* Shared */}
            <Route
              path="/adatkezelesi-tajekoztato"
              element={<PrivacyPolicy />}
            />
            <Route path="/impresszum" element={<Impresszum />} />
            <Route path="/rolunk" element={<Rolunk />} />
            <Route path="/koszonjuk" element={<ThanksPage />} />
            <Route
              path="/koszonjuk-lakossagi"
              element={<ThanksPageRetail />}
            />
          </Routes>
          <Container className="py-0">
            <Footer />
          </Container>
        </CookieConsentProvider>
      </SiteModeProvider>
    </BrowserRouter>
  );
}
